import { ComponentInstall } from "../../utils";
import Image from "./src";

export default ComponentInstall(Image);
